import React from 'react'

const STATUS_ITEMS = [
  { color: '#eab308', label: 'Seleccionado', opacity: 1 },
  { color: '#ef4444', label: 'Ocupado',      opacity: 1 },
  { color: '#374151', label: 'Bloqueado',    opacity: 1 },
  { color: '#4b5563', label: 'Solo presencial', opacity: 0.35 },
] as const

interface SeatMapLegendProps {
  /** Colores hex realmente usados en este evento (vienen de las secciones). */
  availableColors?: string[]
}

/** Leyenda visual: estados de asiento + strip de colores reales del evento. */
export const SeatMapLegend = React.memo(function SeatMapLegend({
  availableColors = ['#22c55e'],
}: SeatMapLegendProps) {
  // Si solo hay 1 color, "Disponible" se muestra con ese color sólido (UX antigua)
  // Si hay >1, se muestra como strip indicando que el color depende de la localidad
  const isSingleColor = availableColors.length <= 1

  return (
    <div className="flex flex-wrap items-center gap-4" role="list" aria-label="Leyenda de asientos">
      <div className="flex items-center gap-1.5" role="listitem">
        {isSingleColor ? (
          <span
            className="inline-block rounded-sm flex-shrink-0"
            style={{ width: 16, height: 16, backgroundColor: availableColors[0] ?? '#22c55e' }}
            aria-hidden="true"
          />
        ) : (
          <span
            className="inline-flex rounded-sm overflow-hidden flex-shrink-0"
            style={{ width: 16, height: 16 }}
            aria-hidden="true"
          >
            {availableColors.map((c) => (
              <span key={c} style={{ flex: 1, backgroundColor: c }} />
            ))}
          </span>
        )}
        <span className="text-sm text-white">
          Disponible
          {!isSingleColor && (
            <span className="text-white/50 text-xs ml-1">(color = localidad)</span>
          )}
        </span>
      </div>

      {STATUS_ITEMS.map(({ color, label, opacity }) => (
        <div key={label} className="flex items-center gap-1.5" role="listitem">
          <span
            className="inline-block rounded-sm"
            style={{ width: 16, height: 16, backgroundColor: color, opacity, flexShrink: 0 }}
            aria-hidden="true"
          />
          <span className="text-sm text-white">{label}</span>
        </div>
      ))}
    </div>
  )
})
